/* eslint-disable no-unused-vars */

export const adminBasePath = '/admin/dash';

export enum AdminSubMenuRoutes {
  DEFAULT = '/legislators',
  LEGISLATOR_LIST = '/legislators',
}
